import { Component, HostListener, inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiService } from '../../common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-explore-land-dialog',
  templateUrl: 'explore-land-dialog.component.html',
  styleUrls: ['explore-land-dialog.component.scss'],
  imports: [MatDialogModule, MatToolbarModule, MatIconModule, TranslateModule],
})
export class ExploreLandDialogComponent implements OnInit {
  url?: SafeResourceUrl;
  height = 0;

  private readonly api = inject(ApiService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly data = inject<{ id: string }>(MAT_DIALOG_DATA);

  async ngOnInit() {
    this.updateSize();
    const { url } = await this.api.exploreLandLink(this.data.id);
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  @HostListener('window:resize')
  updateSize() {
    this.height = window.innerHeight - 98;
  }
}
